import React from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedElement } from "../auth/ProtectedElement";
import { RoleType } from "../models/Role";
import LoginPage from "../pages/LoginPage/LoginPage";
import AccommodationListPage from "../pages/AccommodationListPage/AccommodationListPage";
import AccommodationOverviewPage from "../pages/AccommodationOverviewPage/AccommodationOverviewPage";
import CurrentEventPage from "../pages/CurrentEventPage/CurrentEventPage";
import EventListPage from "../pages/EventListPage/EventListPage";
import EventOverviewPage from "../pages/EventOverviewPage/EventOerviewPage";
import FinishedEventsPage from "../pages/FinishedEventsPage/FinishedEventsPage";
import InvoiceListPage from "../pages/InvoiceListPage/InvoiceListPage";
import InvoiceOverviewPage from "../pages/InvoiceOverviewPage/InvoiceOverviewPage";
import NewAccomodationPage from "../pages/NewAccommodationPage/NewAccommodationPage";
import NewEventPage from "../pages/NewEventPage/NewEventPage";
import NewInvoicePage from "../pages/NewInvoicePage/NewInvoicePage";
import NewRegistrationPage from "../pages/NewRegistrationPage/NewRegistrationPage";
import NewRegistrationCompanyPage from "../pages/NewRegistrationCompanyPage/NewRegistrationCompanyPage";
import NewUserPage from "../pages/NewUserPage/NewUserPage";
import NotificationListPage from "../pages/NotificationListPage/NotificationListPage";
import ParticipantCompanyListPage from "../pages/ParticipantCompanyListPage/ParticipantCompanyListPage";
import ParticipantCompanyOverviewPage from "../pages/ParticipantCompanyOverviewPage/ParticipantCompanyOverviewPage";
import ParticipantListPage from "../pages/ParticipantListPage/ParticipantListPage";
import ParticipantOverviewPage from "../pages/ParticipantOverviewPage/ParticipantOverviewPage";
import RegistrationOverviewPage from "../pages/RegistrationOverviewPage/RegistrationOverviewPage";
import UserListPage from "../pages/UserListPage/UserListPage";
import FinishedEventsComparationPage from "../pages/FinishedEventsComparationPage/FinishedEventsComparationPage";
import RegistrationListPage from "../pages/RegistrationListPage/RegistrationListPage";
import ViewParticipant from "../pages/EventOverviewPage/ViewParticipant";
import ResetPasswordPage from "../pages/ResetPasswordPage/ResetPasswordPage";
import ParticipantListPageInactive from "../pages/ParticipantInactiveListPage/ParticipantListPageInactive";
import NotificationParticipantListPage from "../pages/NotificationParticipantListPage/NotificationParticipantListPage";
import HostEventPage from "../pages/HostEventPage/HostEventPage";
import HostScreen from "../pages/HostEventPage/HostScreen";
import ParticipantOverviewStatistic from "../pages/FinishedEventsComparationPage/ParticipantOverviewStatistic";
import Gallery from "../pages/Gallery/Gallery";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/dashboard"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Test,
              RoleType.Supervizor,
            ]}
          >
            <RegistrationListPage />
            {/* <DashboardPage /> */}
          </ProtectedElement>
        }
      />
      <Route
        path="/accommodation-list"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <AccommodationListPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/accommodation-overview/:id/:accommodationId"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <AccommodationOverviewPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/current-event"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Agency,
              RoleType.Supervizor,
            ]}
          >
            <CurrentEventPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/event-list"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Agency,
              RoleType.Supervizor,
            ]}
          >
            <EventListPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/event-overview/:id"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Agency,
              RoleType.Supervizor,
              RoleType.Supervizor,
            ]}
          >
            <EventOverviewPage />
          </ProtectedElement>
        }
      />

      <Route
        path="/event-overview/registrationStatus/:id/:registrationStatus"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Agency,
              RoleType.Supervizor,
            ]}
          >
            <ViewParticipant />
          </ProtectedElement>
        }
      />
      <Route
        path="/finished-events"
        element={
          <ProtectedElement
            allowedTo={[RoleType.Admin, RoleType.Employee, RoleType.Supervizor]}
          >
            <FinishedEventsPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/events-comparation"
        element={
          <ProtectedElement
            allowedTo={[RoleType.Admin, RoleType.Employee, RoleType.Supervizor]}
          >
            <FinishedEventsComparationPage />
          </ProtectedElement>
        }
      />

      <Route
        path="/events-comparation/participants"
        element={
          <ProtectedElement
            allowedTo={[RoleType.Admin, RoleType.Employee, RoleType.Supervizor]}
          >
            <ParticipantOverviewStatistic />
          </ProtectedElement>
        }
      />

      <Route
        path="/invoice-list"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <InvoiceListPage />
          </ProtectedElement>
        }
      />

      <Route
        path="/invoice-archive"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <InvoiceListPage />
          </ProtectedElement>
        }
      />

      <Route
        path="/invoice-overview/:id"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Agency,
              RoleType.Supervizor,
            ]}
          >
            <InvoiceOverviewPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/new-accommodation"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <NewAccomodationPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/edit-accommodation/:id"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <NewAccomodationPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/new-event"
        element={
          <ProtectedElement
            allowedTo={[RoleType.Admin, RoleType.Employee, RoleType.Supervizor]}
          >
            <NewEventPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/edit-event/:id"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Agency,
              RoleType.Supervizor,
            ]}
          >
            <NewEventPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/new-invoice"
        element={
          <ProtectedElement
            allowedTo={[RoleType.Admin, RoleType.Employee, RoleType.Supervizor]}
          >
            <NewInvoicePage />
          </ProtectedElement>
        }
      />
      <Route
        path="/new-registration"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Test,
              RoleType.Supervizor,
            ]}
          >
            <NewRegistrationPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/edit-registration/:id"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Agency,
              RoleType.Test,
              RoleType.Supervizor,
            ]}
          >
            <NewRegistrationPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/new-registration-company"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Test,
              RoleType.Supervizor,
            ]}
          >
            <NewRegistrationCompanyPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/edit-registration-company/:id"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Employee,
              RoleType.Agency,
              RoleType.Test,
              RoleType.Supervizor,
            ]}
          >
            <NewRegistrationCompanyPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/new-user"
        element={
          <ProtectedElement allowedTo={[RoleType.Admin]}>
            <NewUserPage />
          </ProtectedElement>
        }
      />
      <Route
        path="edit-user/:id"
        element={
          <ProtectedElement allowedTo={[RoleType.Admin]}>
            <NewUserPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/notification-list"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <NotificationListPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/participant-company-list"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <ParticipantCompanyListPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/participant-company-overview"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <ParticipantCompanyOverviewPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/participant-list"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <ParticipantListPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/participant-list/inactive"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <ParticipantListPageInactive />
          </ProtectedElement>
        }
      />
      <Route
        path="/notification-participant"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <NotificationParticipantListPage />
          </ProtectedElement>
        }
      />

      <Route
        path="/host-events"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <HostEventPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/host-events/:id"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <HostScreen />
          </ProtectedElement>
        }
      />
      <Route
        path="/participant-overview/:id"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Supervizor,
            ]}
          >
            <ParticipantOverviewPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/registration-list"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Test,
              RoleType.Supervizor,
            ]}
          >
            <RegistrationListPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/registration-overview"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Test,
              RoleType.Supervizor,
            ]}
          >
            <RegistrationOverviewPage />
          </ProtectedElement>
        }
      />
      <Route
        path="/gallery"
        element={
          <ProtectedElement
            allowedTo={[
              RoleType.Admin,
              RoleType.Agency,
              RoleType.Employee,
              RoleType.Test,
              RoleType.Supervizor,
            ]}
          >
            <Gallery />
          </ProtectedElement>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedElement allowedTo={[RoleType.Admin]}>
            <UserListPage />
          </ProtectedElement>
        }
      />
      <Route path="/" element={<LoginPage />} />
      <Route path="/reset-password/" element={<ResetPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="*" element={<div>nothing here</div>} />
    </Routes>
  );
};
